<agm-map [zoom]="mapZoom" [latitude]="latitude" [longitude]="longitude" (mapReady)="mapReadyHandler($event)">
  <agm-marker *ngFor="let device of deviceList" [latitude]="device.latitude" [longitude]="device.longitude"
    [iconUrl]="device.icon" (markerClick)="onMarkerClicked(device)">
    <agm-info-window [maxWidth]="150" [maxHeight]="150">
      <div id="infoWindow">
        <ng-container *ngIf="device?.systemInfo.reference">{{ device?.systemInfo.reference }}</ng-container>
        <ng-container *ngIf="!device?.systemInfo.reference || device?.systemInfo.name == '' "
          i18n="@@devicelist_device_without_name">Dispositivo senza nome</ng-container>
        <br>
        <br>
        <ng-container i18n="@@useradd_devicesmap_serial">Seriale:</ng-container>{{ device?.serial }}
        <br>
        <br>
        <a (click)="onDetailsButtonClicked(device)" class="button">
          <ng-container i18n="@@owner_devicesmap_details">Dettagli</ng-container> <span>
            <fa-icon icon="search"></fa-icon>
          </span>
        </a>
        <br>
      </div>
    </agm-info-window>
  </agm-marker>
</agm-map>

<app-loading-screen #ownerdevicesmaploader></app-loading-screen>
